<div class="d-flex w-100" [style.opacity]="disabled() ? 0.5 : 1">
    <telxl-avatar
        [presence]="item().presence?.class"
        [variant]="source()"
        icon="fa-light fa-list-tree"
    />
    <div class="user d-flex justify-content-around flex-column pe-2">
        <div class="font-sm weight-medium truncate">
            {{ item().name }}
        </div>
    </div>
    <div class="flex-grow-1 d-flex justify-content-end align-items-center">
        <button
            type="button"
            class="btn btn-no-border p-0"
            (click)="select()"
            (keydown.enter)="select()"
            (keydown.space)="select()"
            tabindex="0"
        >
            <i
                class="fa-xl fa-light fa-circle-arrow-right ivr-icon"
                [class.icon-sel]="selected().selected"
            ></i>
        </button>
    </div>
</div>
